export const initialAuthState = {
  isLoggedIn: false,
  user: null,
  authToken: null,
  ageSubmitted: false,
  baseLineQuizCompleted: false,
  error: "",
  myPoints: 0,
  studentProgress: null,
  isLoading: true,
  baseLineId:0,
  surveyId: 0,
  activeQuizType: null
};

export const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
        authToken: action.payload.token,
      };
    case "LOGOUT":
      return {
        ...initialAuthState,
        isLoading: false,
      };
    case "SET_PROGRESS":
      return {
        ...state,
        myPoints: action.payload.points ?? 0,
        studentProgress: action.payload.progress
      };
    case "SET_BASELINE_QUIZ_COMPLETED":
      return {
        ...state,
        baseLineQuizCompleted: action.payload
      };
    case "SET_AGE_SUBMITTED":
      return {
        ...state,
        ageSubmitted: action.payload
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload
      };
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload
      };
    case "SET_BASELINE_ID":
      return {
        ...state,
        baseLineId: action.payload
      };
    case "SET_SURVEY_ID":
      return {
        ...state,
        surveyId: action.payload
      };
    case "SET_ACTIVE_QUIZ_TYPE":
      return {
        ...state,
        activeQuizType: action.payload
      };
    case "UPDATE_USER":
      return {
        ...state,
        user: { ...state.user, ...action.payload }
      };
      case "SET_ENDLINE_ID":
      return {
        ...state,
        endLineId: action.payload
      };
    default:
      return state;
  }
};
